<template>
  <div class="row g-3 pb-3">
    <div
      class="col-md-23"
      v-if="riskUnits.length > 1"
      :class="{
        'field-required': validation.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid
      }"
    >
      <label class="form-label" for="riskUnit">Unidade de Risco</label>
      <Dropdown
        id="riskUnit"
        :placeholder="riskUnits.length === 0 ? 'Carregando...' : 'Selecione uma unidade de risco'"
        v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
        :options="riskUnits"
        optionLabel="Description"
        optionValue="RiskUnitId"
        dataKey="DamageId"
        :filter="true"
        :showClear="true"
        class="form-control"
        @change="handleChangeRiskUnit"
        :loading="riskUnits.length === 0"
        :disabled="riskUnits.length === 0"
      />
    </div>
    <div
      class="col-md-12"
      :class="{
        'field-required': validation.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid
      }"
      v-if="objDTO.Apolice.UnidadeDeRiscoExternalId && insuranceObjects.length > 1"
    >
      <label class="form-label" for="insuranceObject">Objeto Segurado</label>
      <Dropdown
        id="insuranceObject"
        :placeholder="
          insuranceObjects.length === 0 ? 'Carregando...' : 'Selecione o objeto segurado'
        "
        v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
        :options="insuranceObjects"
        optionLabel="Description"
        :filter="true"
        :showClear="true"
        optionValue="InsuranceObjectId"
        @change="handleChangeInsuranceObject"
        class="form-control"
        :loading="insuranceObjects.length === 0"
        :disabled="insuranceObjects.length <= 1"
      />
    </div>

    <div
      class="col-md-12"
      :class="{
        'field-required': validation.objDTO.Apolice.ApoliceCoberturaId.$invalid
      }"
      v-if="objDTO.Apolice.ObjectoSeguradoExternalId"
    >
      <label class="form-label" for="coverages">Cobertura</label>
      <Dropdown
        id="coverages"
        :placeholder="coverages.length === 0 ? 'Carregando...' : 'Selecione a cobertura'"
        @change="changeCoverage"
        v-model="objDTO.Apolice.ApoliceCoberturaId"
        :options="coverages"
        :filter="true"
        :showClear="true"
        optionLabel="Description"
        optionValue="GisCoverageId"
        :loading="coverages.length === 0"
        class="form-control"
        :disabled="coverages.length <= 1"
      />
    </div>
    <div
      class="col-md-12"
      :class="{
        'field-required': validation.objDTO.Sinistro.SinistroEventoId.$invalid
      }"
      v-if="objDTO.Apolice.ApoliceCoberturaId"
    >
      <label class="form-label" for="evento">Natureza</label>
      <Dropdown
        id="evento"
        :placeholder="events.length === 0 ? 'Carregando...' : 'Selecione a natureza do sinistro'"
        v-model="objDTO.Sinistro.SinistroEventoId"
        :options="events"
        optionLabel="Description"
        optionValue="Id"
        :showClear="true"
        :filter="true"
        :loading="events.length === 0"
        class="form-control"
        :disabled="events.length === 0"
      />
    </div>
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';
  import customParseFormat from 'dayjs/plugin/customParseFormat';
  import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
  import { mapGetters } from 'vuex';

  dayjs.extend(utc);
  dayjs.extend(customParseFormat);
  dayjs.extend(isSameOrAfter);

  export default {
    props: {
      validation: Object,
      riskUnits: Array,
      insuranceObjects: Array,
      coverages: Array,
      events: Array
    },
    computed: {
      ...mapGetters({ objDTO: 'getObjDTO' })
    },
    methods: {
      handleChangeRiskUnit() {
        this.$emit('riskUnitChange');
      },
      handleChangeInsuranceObject() {
        this.$emit('insuranceObjectChange');
      },
      async changeCoverage() {
        this.$emit('coverageChange');
      }
    }
  };
</script>
